module.exports = __webpack_public_path__ + "static/media/it.47a64a1b.svg";